import axios from 'axios';

export default (token = false) => {

    return axios.create({
        baseURL: `${process.env.REACT_APP_API_BASE_URL}/client/`,
        headers: {
             'content-type': 'application/json',
             
            'authorization': `Bearer ${token}`
        },
        
    })
}